// import React from "react";

// const Slide = () => {
//   return <div>
//     import React, { useState } from 'react';
// import { ArrowLeftIcon, ArrowRightIcon } from '@heroicons/react/solid';

// const images = [
//    "https://via.placeholder.com/500x500?text=Product%201",
//   "https://via.placeholder.com/500x500?text=Product%202",
//   "https://via.placeholder.com/500x500?text=Product%203",
//   "https://via.placeholder.com/500x500?text=Product%204",
// ];

// function ProductDescriptionPage() {
//   const [currentImageIndex, setCurrentImageIndex] = useState(0);

//   const previousImage = () => {
//     setCurrentImageIndex(currentImageIndex === 0 ? images.length - 1 : currentImageIndex - 1);
//   };

//   const nextImage = () => {
//     setCurrentImageIndex(currentImageIndex === images.length - 1 ? 0 : currentImageIndex + 1);
//   };

//   return (
//     <div className="container mx-auto py-8">
//       <div className="flex justify-center">
//         <div className="w-3/4">
//           <div className="relative">
//             <img src={images[currentImageIndex]} alt="Product" className="w-full h-auto" />

//             <div className="absolute inset-0 flex justify-between items-center">
//               <button onClick={previousImage} className="px-4 py-2 bg-white shadow-lg rounded-full">
//                 <ArrowLeftIcon className="h-6 w-6" />
//               </button>

//               <button onClick={nextImage} className="px-4 py-2 bg-white shadow-lg rounded-full">
//                 <ArrowRightIcon className="h-6 w-6" />
//               </button>
//             </div>
//           </div>

//           <div className="flex mt-8">
//             {

//   </div>;
// };

// export default Slide;

import React from "react";
import styled from "styled-components";
/* transiction  */

import { Transition } from "react-transition-group";
import { useRef } from "react";
import { useState } from "react";

// Usually you would just need to import one of the following
import {
  useScrollPosition,
  useScrollXPosition,
  useScrollYPosition,
} from "react-use-scroll-position";

// ## Creating a button styled-component that will render a button with some styles.

const ButtonStyles = styled.button`
  font-family: "Poppins", sans-serif;
  border: none;
  border-radius: 0;
  padding-inline: 1.75rem;
  padding-block: 0.75rem;
  background-color: springGreen;
  color: white;
`;

const H1Style = styled.h1`
  color: yellow;
  background-color: springGreen;
  padding: 20px 0;
  margin: 10px;
`;

const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  background: #000;

  h2 {
    font-weight: 400;
    color: violet;
    font-size: 1rem;
  }

  li {
    list-style: none;
    display: inline-block;
    color: #ccc;
  }
`;

const Main = styled.main`
  color: red;
`;
const Slide = () => {
  return (
    <>
      <H1Style>
        <p>Hello</p>
      </H1Style>

      <ButtonStyles>
        ## Now, our styles will get applied. Hello World!
      </ButtonStyles>

      <div>
        <Header>
          {/*styled component is referenced here.*/}
          <h2>Hello World</h2>
          <ul>
            <li>About</li>
          </ul>
        </Header>
        <Main>
          <h2>I am a child element!</h2>
        </Main>
      </div>

      <Fade />
      <Example />
    </>
  );
};

const duration = 10000;

const defaultStyle = {
  transition: `opacity ${duration}ms ease-in-out`,
  opacity: 0,
};

const transitionStyles = {
  entering: { opacity: 1 },
  entered: { opacity: 1 },
  exiting: { opacity: 0 },
  exited: { opacity: 0 },
};

function Fade({ in: inProp }) {
  const nodeRef = useRef(null);
  return (
    <Transition nodeRef={nodeRef} in={inProp} timeout={duration}>
      {(state) => (
        <div
          ref={nodeRef}
          style={{
            ...defaultStyle,
            ...transitionStyles[state],
          }}
        >
          I'm a fade Transition!
        </div>
      )}
    </Transition>
  );
}

function Example() {
  const { x, y } = useScrollPosition();
  const scrollX = useScrollXPosition();
  const scrollY = useScrollYPosition();
  return (
    <>
      <p>
        {x} should equal to {scrollX}.
      </p>
      <p>
        {y} should equal to {scrollY}.
      </p>
    </>
  );
}

export default Slide;
